export default __webpack_public_path__ + "static/media/school-img3.66c4432e.png";